<template>
	<div class="pt-8 px-4 lg:pt-16 h-full max-w-5xl mx-auto">
		<h3 class="w-full flex flex-col text-center font-semibold text-4xl lg:text-5xl">
			<span class="text-primary">
				{{ $t('press.title1') }}
			</span>
			<span class="text-highlighted">
				{{ $t('press.title2') }}
			</span>
		</h3>
		<p class="text-center text-sm lg:text-lg mt-4 text-highlighted">
			{{ $t('press.description') }}
		</p>
		<div class="py-12">
			<div
				v-for="article in articles"
				:key="article.key"
				class="py-8 border-t-1 border-dimmed"
			>
				<h3 class="text-xl font-bold">
					{{ article.title }}
				</h3>
				<NuxtLink
					:to="article.link.url"
					:target="article.link.target"
					class="text-sm transition-all duration-100 text-primary hover:underline underline-offset-2 decoration-2 decoration-primary"
				>
					{{ article.linkText }}
				</NuxtLink>
				<p class="mt-2 text-sm text-gray-500">
					{{ getDate(article.date, locale, 'short') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useStoryblokWithErrorReporting } from '@/composables/useStoryblok'
import { BASE_URL } from '@/constants/index.js'
import { OG_IMAGE_DEFAULT } from '@/constants/og-image'
import { getDate } from '@/utils/getDate'
import { useI18n } from 'vue-i18n'

const { getStory } = useStoryblokWithErrorReporting()
const {
	t, locale
} = useI18n({ useScope: 'global' })

const storyblok = await getStory('press')

const { story } = storyblok.value?.data || {}

const articles = computed(() => {
	return story?.content?.grid?.map((article: any) => {
		return {
			key: article._uid,
			title: article.title,
			date: article.date,
			link: article.link,
			linkText: article.link_text
		}
	})
})

useHead({
	title: t('press.title'),
	meta: [
		{ name: 'description',
			content: t('press.description') },
		{ name: 'url',
			content: `${BASE_URL}/press` }
	],
	link: [
		{
			rel: 'icon',
			type: 'image/x-icon',
			href: '/favicons/favicon.ico'
		}
	]
})

const {
	title, description
} = story?.content?.metatags || {
	title: t('press.meta-title'),
	description: t('press.description')
}

useSeoMeta({
	title: () => title,
	ogTitle: () => title,
	description: () => description,
	ogDescription: () => description,
	ogUrl: () => BASE_URL,
	twitterTitle: () => title,
	twitterDescription: () => description,
	twitterImage: () => '/images/og-image-fallback.png',
	twitterCard: () => 'summary_large_image'
})
 import.meta.prerender && defineOgImage('Default', OG_IMAGE_DEFAULT)
</script>
